.eyeIcon {
  fill: var(--blue-02);
}
